export { default as GDMFormControl } from './GDMFormControl';

export type { GDMFormControlComponent, GDMFormControlProps } from './GDMFormControl.type';
